import React, { Component, Fragment } from "react";
import { useState } from 'react';

import { Container, Row, Col, Button, Card, Form } from 'react-bootstrap'
import { slide as Menu } from 'react-burger-menu'


import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import './App.css';
import VerifyDocument from "./components/VerifyDocumentComponent";
import AboutEvrfy from "./components/AboutComponent";
import Faqs from "./components/FaqComponent";
import Help from "./components/HelpComponent";
import Download from "./components/DownloadComponent";
import Header from './components/Header';
import Footer from './components/Footer';


import FAQs from "./components/FaqComponent";
//import HowTo from "./components/HowToComponent";

function App() {
  const [data, setData] = React.useState(null);
  
  return (
    <Router>
      
      <div className="container-fluid vrfy-container" id="vrfy-main-container">

      <Menu pageWrapId={ "vrfy-main" }  outerContainerId={ "vrfy-main-container" } right>
        <a id="home" className="menu-item" href="/">Home</a>
        <a id="about" className="menu-item" href="/about">About</a>
        {/*
        <a id="faq" className="menu-item" href="/faqs">FAQs</a>
        */} 
        <a id="help" className="menu-item" href="/help">Help</a>
      </Menu>

      

        {/* HEADER +++++++++++++++++++++++++++++++ */}
        <Header/>

        {/* MAIN +++++++++++++++++++++++++++++++++ */}
          <main className="vrfy-main" id="vrfy-main">
            <div id="main-inner">
                <div xs={1} md={12} tag="section" className="row-inner">
                  <Switch>         
                    <Route exact path={["/"]} component={VerifyDocument} />
                    <Route exact path={["/about"]} component={AboutEvrfy} />
                    <Route exact path={["/help"]} component={Help} />
                    <Route exact path={["/downloads/:ac/:cn", "/downloads/*", "/downloads"]} component={Download} />
                    {/*
                    <Route exact path={["/faqs"]} component={Faqs} />
                    <Route exact path={["/how-to"]} component={HowTo} />
                    */} 
                  </Switch>
                </div>
              </div>
          </main>


          {/* FOOTER +++++++++++++++++++++++++++++++ */}
          <Footer />
      </div>
    </Router>
  );
}
export default App;